/**
 * Quick-add forms on product cards.
 * Intercepts submit, posts to /cart/add.js, gives button feedback.
 * No-op if a real product form or checkout flow handles the event.
 */
(function () {
  'use strict';

  function updateCartCount(quantity) {
    const counters = document.querySelectorAll('[data-cart-count], .site-header__cart-count');
    counters.forEach(function (el) {
      el.textContent = quantity;
      el.hidden = quantity === 0;
    });
    // Fallback for the simple <sup> rendered by header.liquid
    const headerCart = document.querySelector('a[href*="/cart"] sup');
    if (headerCart) {
      headerCart.textContent = quantity;
      headerCart.style.display = quantity === 0 ? 'none' : '';
    }
  }

  async function fetchCart() {
    try {
      const res = await fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js');
      if (!res.ok) return;
      const cart = await res.json();
      updateCartCount(cart.item_count);
    } catch (e) {
      // silent
    }
  }

  /* Quantity steppers on quick-add forms. Delegated so every card
     (multiple grid instances) shares one listener. */
  document.addEventListener('click', function (event) {
    const btn = event.target.closest('[data-qty-step]');
    if (!btn) return;
    const wrap = btn.closest('[data-qty]');
    const input = wrap && wrap.querySelector('input[name="quantity"]');
    if (!input) return;
    let value = parseInt(input.value, 10) || 1;
    value = btn.getAttribute('data-qty-step') === 'plus' ? value + 1 : Math.max(1, value - 1);
    input.value = value;
  });

  document.addEventListener('submit', async function (event) {
    const form = event.target.closest('[data-type="quick-add-form"]');
    if (!form) return;

    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (!button || button.disabled) return;

    const originalHTML = button.innerHTML;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const idInput = form.querySelector('input[name="id"]');
      const qtyInput = form.querySelector('input[name="quantity"]');
      const id = idInput ? idInput.value : null;
      const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (!id) throw new Error('missing variant id');

      const endpoint = form.action.endsWith('.js') ? form.action : (form.action.replace(/\/+$/, '') + '.js');
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: quantity }] }),
      });

      if (!res.ok) {
        const err = await res.json().catch(function () { return {}; });
        throw new Error(err.description || res.statusText);
      }

      await fetchCart();
      button.removeAttribute('aria-busy');
      button.classList.add('is-success');
      setTimeout(function () {
        button.disabled = false;
        button.classList.remove('is-success');
        button.innerHTML = originalHTML;
      }, 1500);
    } catch (err) {
      button.removeAttribute('aria-busy');
      button.classList.add('is-error');
      // eslint-disable-next-line no-console
      console.error('Quick add failed:', err);
      setTimeout(function () {
        button.disabled = false;
        button.classList.remove('is-error');
        button.innerHTML = originalHTML;
      }, 1500);
    }
  });
})();
